<template>
  <div class="authTemplate">
    <button class="close_btn" @click="closeModals">&times;</button>
    <div class="round_1"></div>
    <div class="round_2"></div>
    <div class="auth_container">
      <router-link to="/" class="logo">
        <img src="../assets/images/header/logo.svg" alt="">
      </router-link>
      <slot></slot>
      <div class="bottom" v-if="type === 'register'">
        <p>Уже есть аккаунт?</p>
        <a @click.prevent="openModal('login')">Войти</a>
      </div>
      <div class="bottom" v-else-if="type === 'login'">
        <p>Еще нет аккаунта?</p>
        <a @click.prevent="openModal('register_main')">Зарегистрироваться</a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'AuthTemplate',
  props: {
    type: String
  },
  methods: mapMutations(['openModal', 'closeModals'])
}
</script>

<style lang="scss">
// TODO: adaptive for
.authTemplate {
  max-width: 400px;
  width: 100%;
  background-color: #fff;
  overflow: hidden;
  position: relative;
  height: 100vh;
  max-height: 650px;
  border-radius: 10px;

  .close_btn {
    display: none;
  }

  .round_1, .round_2 {
    pointer-events: none;
    z-index: 1;
    position: absolute;
    opacity: 0.3;
    border-radius: 50%;
  }

  .round_1 {
    background: #FFD2B4;
    width: 400px;
    height: 400px;
    left: -276px;
    top: -249px;
  }

  .round_2 {
    background: #97C1BF;
    width: 200px;
    height: 200px;
    bottom: -84px;
    right: -126px;
  }

  .auth_container {
    position: relative;
    min-height: calc(100% - 50px);
    z-index: 2;
    max-width: 330px;
    padding: 0 15px 125px 15px;
    margin: 0 auto;

    h1 {
      font-weight: 600;
      font-size: 32px;
      line-height: 1.25;
      text-align: center;
      color: #383838;
      margin-bottom: 50px;
      padding-top: 0;
    }
  }

  .logo {
    display: block;
    width: 184px;
    height: 60px;
    margin: 50px auto 80px auto;
  }

  .bottom {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 30px;
    text-align: center;
    font-family: "Open Sans", sans-serif;

    p {
      font-size: 14px;
      line-height: 1.71;
      color: #808080;
      margin-bottom: 10px;
    }

    a {
      font-weight: 600;
      font-size: 16px;
      line-height: 1.5;
      color: #B9765B;
      text-decoration: none;
    }
  }
}

@media screen and (max-width: 576px) {
  .authTemplate {
    position: absolute;
    height: auto;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    max-width: 100%;
    max-height: 100%;
    .close_btn {
      background-color: transparent;
      display: block;
      position: absolute;
      right: 20px;
      top: 20px;
      border: none;
      font-size: 40px;
    }
  }
}
</style>
